import { OnboardingStep } from '../../types/onboarding';

// Determine previous step based on current step and state
const getPrevStep = (
  currentStep: OnboardingStep,
  flowSteps: OnboardingStep[],
): OnboardingStep | null => {
  const currentIndex = flowSteps.indexOf(currentStep);
  if (currentIndex > 0) {
    return flowSteps[currentIndex - 1];
  }

  return null;
};

export default getPrevStep;
